export default {
  courseOutlineAssessment: {
    id: '',
    courseOutline: null,
    assessment: null,
    seq: null,
    percent: null,
    score: null,
  },
  courseOutlineAssessments: [],
  processing: false,
  error: null,
  success: null,
}



